import { render, staticRenderFns } from "./ContentLoader.vue?vue&type=template&id=3b320b2a&scoped=true&"
var script = {}
import style0 from "./ContentLoader.vue?vue&type=style&index=0&id=3b320b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b320b2a",
  null
  
)

export default component.exports